// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"8f97af63ebc1a6a15f92","966":"db3735ad129c601c6f82"}[chunkId] + ".js";
};